import React from "react";
import "./WhatsappButton.css";

export const WhatsAppButton: React.FC = () => {
  return (
    <a
      href="https://wa.me/96171077605"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      {/* Inline WhatsApp SVG (no libraries needed) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="30"
        viewBox="0 0 32 32"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M16.003 3C9.376 3 4 8.376 4 15.003c0 2.65.75 5.14 2.16 7.326L4 29l6.873-2.127A12.942 12.942 0 0016.003 27c6.627 0 12.003-5.376 12.003-11.997C28.006 8.376 22.63 3 16.003 3zm0 22.33c-2.09 0-4.124-.56-5.91-1.627l-.422-.25-4.09 1.264 1.34-3.94-.274-.435A9.91 9.91 0 016.09 15c0-5.445 4.447-9.87 9.91-9.87 5.465 0 9.91 4.425 9.91 9.87 0 5.444-4.445 9.87-9.91 9.87zm5.31-7.42c-.29-.144-1.717-.847-1.984-.94-.268-.095-.463-.145-.658.145-.194.29-.756.94-.927 1.134-.17.195-.341.219-.63.074-.29-.145-1.225-.45-2.334-1.43-.862-.767-1.446-1.714-1.616-2.004-.17-.29-.018-.447.128-.592.13-.13.29-.341.436-.511.145-.17.194-.29.29-.485.096-.194.048-.365-.024-.51-.072-.145-.658-1.59-.902-2.178-.24-.577-.485-.498-.658-.508l-.562-.01c-.195 0-.51.073-.778.365-.268.29-1.02.996-1.02 2.429s1.044 2.82 1.188 3.014c.145.194 2.055 3.136 5.013 4.395.702.302 1.25.482 1.678.618.705.224 1.345.192 1.852.117.565-.085 1.717-.7 1.96-1.375.242-.675.242-1.252.17-1.376-.072-.122-.268-.195-.558-.34z" />
      </svg>
      
    </a>
  );
};
export default WhatsAppButton;
